export const MIME_TYPES = {
  // IMAGES
  'image/avif': {category: 'Image', extension: 'avif'},
  'image/bmp': {category: 'Image', extension: 'bmp'},
  'image/gif': {category: 'Image', extension: 'gif'},
  'image/jpeg': {category: 'Image', extension: ['jpeg', 'jpg']},
  'image/png': {category: 'Image', extension: 'png'},
  'image/svg+xml': {category: 'Image', extension: 'svg'},
  'image/webp': {category: 'Image', extension: 'webp'},
  // ICONS
  'image/vnd.microsoft.icon': {category: 'Icon', extension: 'ico'},
  // DOCUMENTS
  'application/msword': {category: 'Document', extension: 'doc'},
  'application/pdf': {category: 'Document', extension: 'pdf'},
  'application/vnd.ms-excel': {category: 'Document', extension: 'xls'},
  'application/vnd.ms-powerpoint': {category: 'Document', extension: 'ppt'},
  'application/vnd.oasis.opendocument.presentation': {
    category: 'Document',
    extension: 'odp',
  },
  'application/vnd.oasis.opendocument.spreadsheet': {
    category: 'Document',
    extension: 'ods',
  },
  'application/vnd.oasis.opendocument.text': {
    category: 'Document',
    extension: 'odt',
  },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
    category: 'Document',
    extension: 'pptx',
  },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    category: 'Document',
    extension: 'xlsx',
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    category: 'Document',
    extension: 'docx',
  },
  'text/csv': {category: 'Document', extension: 'csv'},
  'text/markdown': {category: 'Document', extension: 'md'},
  'text/plain': {category: 'Document', extension: 'txt'},
  'application/zip': {category: 'Document', extension: 'zip'},
  // FONTS
  'application/vnd.ms-fontobject': {category: 'Font', extension: 'eot'},
  'font/otf': {category: 'Font', extension: 'otf'},
  'font/ttf': {category: 'Font', extension: 'ttf'},
  'font/woff': {category: 'Font', extension: 'woff'},
  'font/woff2': {category: 'Font', extension: 'woff2'},
  // VIDEOS
  'video/mp4': {category: 'Video', extension: 'mp4'},
  'video/quicktime': {category: 'Video', extension: 'mov'},
  'video/webm': {category: 'Video', extension: 'webm'},
  'video/ogg': {category: 'Video', extension: 'ogg'},
  'video/mpeg': {category: 'Video', extension: 'mpeg'},
  // LOTTIE
  'application/json': {category: 'Lottie', extension: 'json'},
  'application/octet-stream': {category: 'Lottie', extension: 'lottie'},
  // RIVE
  'application/vnd.rive': {category: 'Rive', extension: 'riv'},
  // AUDIO
  'audio/mpeg': {category: 'Audio', extension: 'mp3'},
  'audio/ogg': {category: 'Audio', extension: 'ogg'},
};

export const LOTTIE_MIME_TYPES = [
  'application/json',
  'application/octet-stream',
] as const;

export const RIVE_MIME_TYPES = [
  'application/octet-stream',
  'application/vnd.rive',
] as const;

// An index of { [extension] => {mime, category} } derived from MIME_TYPES
export const EXTENSIONS = Object.fromEntries(
  Object.entries(MIME_TYPES).reduce<
    Array<[string, {mime: string; category: string}]>
  >((acc, [mime, {category, extension}]) => {
    // Because some extensions are arrays we need to flatten them
    if (Array.isArray(extension)) {
      extension.forEach((ext) => {
        acc.push([ext, {mime, category}]);
      });
    } else {
      acc.push([extension, {mime, category}]);
    }
    return acc;
  }, [])
);

export const SUPPORTED_IMAGE_MIMETYPES = {
  'image/jpeg': 'jpeg',
  'image/jpg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/svg+xml': 'svg',
  'image/bmp': 'bmp',
  'image/webp': 'webp',
  'image/avif': 'avif',
} as const;

export const SUPPORTED_DOCUMENT_MIMETYPES = {
  'application/pdf': 'pdf',
  'application/msword': 'doc',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'pptx',
  'text/plain': 'txt',
  'text/markdown': 'md',
  'text/csv': 'csv',
  'application/vnd.oasis.opendocument.text': 'odt',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',
  'application/vnd.oasis.opendocument.presentation': 'odp',
  'application/json': 'json',
  'application/vnd.rive': 'riv',
  'application/zip': 'zip',
} as const;

export const SUPPORTED_AUDIO_MIMETYPES = {
  'audio/mpeg': 'mp3',
  'audio/ogg': 'ogg',
} as const;
